<div class="card mb-3 border-info">
  <div class="card-header bg-info bg-opacity-10 py-2">
    <strong class="small text-uppercase text-muted">Build from linked lesson</strong>
    <div class="d-flex flex-wrap align-items-center gap-2 mt-2">
      <label class="mb-0 small d-flex align-items-center gap-1">
        <input type="checkbox" [(ngModel)]="replaceExistingFromLesson">
        Step 1: replace existing slides
      </label>
      <button type="button" class="btn btn-sm btn-outline-primary" (click)="runBuildStep1()" [disabled]="loadingStep1">
        {{ loadingStep1 ? '…' : '1. TOC → slides' }}
      </button>
      <button type="button" class="btn btn-sm btn-outline-primary" (click)="runBuildStep2()" [disabled]="loadingStep2">
        {{ loadingStep2 ? '…' : '2. Seed lines' }}
      </button>
      <button type="button" class="btn btn-sm btn-outline-primary" (click)="runBuildStep3()" [disabled]="loadingStep3">
        {{ loadingStep3 ? '…' : '3. Map content' }}
      </button>
    </div>
    <p class="small text-muted mb-0 mt-2">Set slide types on each row after step 1, then run step 2, then step 3.</p>
  </div>
</div>

<div class="card mb-3 border-secondary">
  <div class="card-header bg-secondary bg-opacity-10 py-2">
    <strong class="small text-uppercase text-muted">Project assets (common images/audio)</strong>
    <div class="small text-muted mt-1">Uploads to `projects/{{projectCode}}/images` or `projects/{{projectCode}}/audio` for packaging / default buttons/sounds.</div>
  </div>
  <div class="card-body">
    <div class="row g-2 align-items-end">
      <div class="col-md-2">
        <label class="form-label small mb-1">Type</label>
        <select class="form-select form-select-sm" [(ngModel)]="commonAssetType">
          <option [ngValue]="'IMAGE'">IMAGE</option>
          <option [ngValue]="'AUDIO'">AUDIO</option>
        </select>
      </div>
      <div class="col-md-7">
        <label class="form-label small mb-1">File</label>
        <input type="file" class="form-control form-control-sm" (change)="onCommonAssetFileSelected($event)" />
      </div>
      <div class="col-md-3 text-end">
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="uploadCommonAsset()" [disabled]="uploadingCommon || !commonAssetFile">
          {{ uploadingCommon ? 'Uploading…' : 'Upload' }}
        </button>
      </div>
    </div>
    <hr class="my-3" />
    <div class="small text-muted mb-2">
      Or upload a ZIP of project media. Required layout:
      <code>images/&lt;file&gt;</code> and/or <code>audio/&lt;file&gt;</code>
      (extracted under <code>projects/{{ projectCode }}/</code>). Existing files prompt for overwrite.
    </div>
    <div class="d-flex flex-wrap gap-2 align-items-center">
      <label class="btn btn-sm btn-outline-primary mb-0" [class.disabled]="uploadingAssetsZip">
        {{ uploadingAssetsZip ? 'Extracting ZIP…' : 'Upload assets ZIP' }}
        <input
          type="file"
          accept=".zip,application/zip"
          hidden
          (change)="onAssetsZipSelected($event)"
          [disabled]="uploadingAssetsZip" />
      </label>
      <span class="text-muted small" *ngIf="assetsZipFileName">{{ assetsZipFileName }}</span>
    </div>
  </div>
</div>

<div class="card">
  <div class="card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
    <div class="d-flex align-items-center gap-2 flex-wrap">
      <h5 class="mb-0">Slides for {{ projectCode }}</h5>
      <label class="mb-0 small text-muted d-flex align-items-center gap-1">
        Current language
        <select class="form-select form-select-sm" style="width: auto; min-width: 11rem;"
          [(ngModel)]="projectCurrentLanguage">
          <option value="">EN — English (source)</option>
          <option *ngFor="let lang of languages" [value]="lang.LanguageShortCode">
            {{ lang.LanguageShortCode }} — {{ lang.LanguageName }}
          </option>
        </select>
      </label>
    </div>
    <div>
      <button class="btn btn-sm btn-success me-2" (click)="openAddSlide()">+ New Slide</button>
      <button class="btn btn-outline-secondary btn-sm me-2" (click)="selectAllToggle()">
        {{ allSelected ? 'Unselect All' : 'Select All' }}
      </button>
      <div class="btn-group me-2">
        <button class="btn btn-primary btn-sm" (click)="checkSlides()" [disabled]="loading_chk">{{ loading_chk ? 'Checking...' : 'Check' }}</button>
       </div>
       <div class="btn-group me-2">
        <button class="btn btn-primary btn-sm" (click)="createDependencyList()" [disabled]="loading_dep">{{ loading_dep ? 'Creating Dependency List...' : 'Create Dependency List' }}</button>
       </div>
       <div class="btn-group me-2">
        <button class="btn btn-primary btn-sm" (click)="exportForPPT()" [disabled]="loading_exp">{{ loading_exp ? 'Exporting...' : 'Export for PPT' }}</button>
      </div>
     
      <button class="btn btn-danger btn-sm" (click)="deleteSelected()">Delete Selected</button>
    </div>
  </div>

  <div class="card-body p-0">
    <table class="table table-hover mb-0">
      <thead class="table-light">
        <tr>
          <th></th>
          <th>Sr No</th>
          <th>Title</th>
          <th>Layout Short Code</th>
          <th>Slide type</th>
          <th>Remarks</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let slide of slides; let i = index">
          <tr [attr.id]="'ps-row-' + slide.ProjectSlideId" tabindex="-1">
            <td><input type="checkbox" [checked]="slide.selected" (change)="toggleSelect(slide)"></td>
            <td>{{ slide.SlideSrNo }}</td>
            <td>
              <strong>{{ slide.slideTitle }}</strong>
              <div *ngIf="slide.checked" class="small text-success">(checked)</div>
            </td>
            <td>{{ slide.slideLayoutSC }}</td>
            <td style="min-width: 12rem;">
              <select class="form-select form-select-sm" [(ngModel)]="slide.slideType">
                <option value="">— Select —</option>
                <option *ngFor="let st of slideTypeShortcodes" [value]="st.slideTypeShortcode">
                  {{ st.slideTypeShortcode }}
                </option>
              </select>
            </td>
            <td>{{ displaySlideRemarks(slide) }}</td>
            <td>
              <button class="btn btn-sm btn-outline-secondary" (click)="moveUp(i)" [disabled]="i===0">▲</button>
              <button class="btn btn-sm btn-outline-secondary" (click)="moveDown(i)"
                [disabled]="i===slides.length-1">▼</button>
              <button class="btn btn-sm btn-outline-primary" (click)="saveSlideMeta(slide)" [disabled]="savingSlideId===slide.ProjectSlideId">
                {{ savingSlideId===slide.ProjectSlideId ? 'Saving…' : 'Save' }}
              </button>
              <button class="btn btn-sm btn-outline-success" (click)="seedLinesForSlide(slide)"
                [disabled]="seedingSlideId===slide.ProjectSlideId || clearSeedingSlideId===slide.ProjectSlideId || (slide.lineCount || 0) > 0">
                {{ (slide.lineCount || 0) > 0 ? 'Seeded' : (seedingSlideId===slide.ProjectSlideId ? 'Seeding…' : 'Seed lines') }}
              </button>
              <button class="btn btn-sm btn-outline-warning" type="button" (click)="clearAndSeedLinesForSlide(slide)"
                [disabled]="seedingSlideId===slide.ProjectSlideId || clearSeedingSlideId===slide.ProjectSlideId || !(slide.slideType||'').trim()">
                {{ clearSeedingSlideId===slide.ProjectSlideId ? 'Clear & seed…' : 'Clear & seed' }}
              </button>
              <button *ngIf="!isSectionBreakSlide(slide)" class="btn btn-sm btn-outline-secondary" (click)="togglePreview(slide)">
                {{ previewSlideId===slide.ProjectSlideId ? 'Hide preview' : 'Preview' }}
              </button>
              <button class="btn btn-sm btn-outline-primary" (click)="editSlide(slide)">Edit</button>
              <button class="btn btn-sm btn-outline-danger" (click)="deleteSlide(slide)">Delete</button>
            </td>
          </tr>
          <tr *ngIf="previewSlideId===slide.ProjectSlideId && !isSectionBreakSlide(slide)">
            <td colspan="7" class="bg-light">
              <div class="p-2 border rounded">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="fw-semibold">{{ previewTitle }}</div>
                  <div class="small text-muted">Approx preview (not PPT render)</div>
                </div>
                <div *ngIf="previewLoading" class="small text-muted mt-2">Loading preview…</div>
                <div class="row g-2 mt-2" *ngIf="!previewLoading">
                  <div class="col-md-5" *ngIf="previewImageUrl">
                    <img [src]="previewImageUrl" (error)="onPreviewImageError($event)" class="img-fluid rounded border" alt="slide image preview" />
                  </div>
                  <div class="col">
                    <div *ngIf="!previewTextLines.length" class="small text-muted">No TEXT elements in this lesson slide yet.</div>
                    <div *ngFor="let ln of previewTextLines" class="small" [style.marginLeft.px]="previewIndentPx(ln.indent)">
                      <span *ngIf="ln.bullet">•</span>
                      {{ ln.text }}
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </ng-container>
        <tr *ngIf="slides.length === 0">
          <td colspan="7" class="text-center py-4">No slides available</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Add Slide Modal -->
<div class="modal fade" tabindex="-1" [class.show]="showAddForm" style="display: block;" *ngIf="showAddForm">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Add New Slide</h5>
        <button type="button" class="btn-close" (click)="showAddForm=false"></button>
      </div>
      <div class="modal-body">
        <div class="mb-3">
          <label class="form-label">Title</label>
          <input type="text" class="form-control" [(ngModel)]="newSlide.slideTitle">
        </div>

        <div class="mb-3">
          <label class="form-label">Layout Short Code</label>
          <select class="form-select" [(ngModel)]="newSlide.slideLayoutSC">
            <option *ngFor="let code of layoutOptions" [value]="code">{{ code }}</option>
          </select>
        </div>

                <div class="mb-3">
          <label class="form-label">Slide Type Short Code</label>
          <select class="form-select" [(ngModel)]="newSlide.slideType">
            <option *ngFor="let slideTypeShortcode of slideTypeShortcodes" [value]="slideTypeShortcode.slideTypeShortcode">{{ slideTypeShortcode.slideTypeShortcode}}</option>
          </select>
        </div>


        <div class="mb-3">
          <label class="form-label">Remarks</label>
          <textarea class="form-control" [(ngModel)]="newSlide.slideRemarks"></textarea>
        </div>
        <div class="mb-3">
          <label class="form-label">Insert at position</label>
          <select class="form-select" [(ngModel)]="newSlide.SlideSrNo">
            <option *ngFor="let pos of [].constructor(slides.length + 1); let i = index" [ngValue]="i + 1">
              {{ i + 1 }}{{ i === 0 ? ' (beginning)' : '' }}
            </option>
          </select>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="showAddForm=false">Cancel</button>
        <button class="btn btn-primary" (click)="saveNewSlide()">Save</button>
      </div>
    </div>
  </div>
</div>